import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css'

import { BrowserRouter, Routes, Route, Switch } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
/*  
  <React.StrictMode>
    <App />
  </React.StrictMode>
*/  
);



root.render(  
    <App />
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
